import React from 'react';
import styled from 'styled-components';

import WellnessIllustration from '@joinforma/ui/assets/illustrations/account-wellness.svg';
import RecognitionIllustration from '@joinforma/ui/assets/illustrations/account-recognition.svg';
import FamilyIllustration from '@joinforma/ui/assets/illustrations/account-family.svg';
import PetsIllustration from '@joinforma/ui/assets/illustrations/account-pets.svg';
import WorkFromHomeIllustration from '@joinforma/ui/assets/illustrations/account-work-from-home.svg';
import CommuterIllustration from '@joinforma/ui/assets/illustrations/account-commuter.svg';
import CustomIllustration from '@joinforma/ui/assets/illustrations/account-custom.svg';
import HsaIllustration from '@joinforma/ui/assets/illustrations/account-hsa.svg';
import FsaIllustration from '@joinforma/ui/assets/illustrations/account-fsa.svg';
import ParkingIllustration from '@joinforma/ui/assets/illustrations/account-parking.svg';
import TransitIllustration from '@joinforma/ui/assets/illustrations/account-transit.svg';

import { PRETAX_ACCOUNT_TYPES, TWIC_ACCOUNT_TYPES } from 'constants/accounts';

const WalletImg = styled.img`
  width: 44px;
  height: 44px;
`;

const getIllustrationImg = (account_type: string) => {
  switch (account_type.toLowerCase()) {
    case PRETAX_ACCOUNT_TYPES.TRANSIT:
      return TransitIllustration;
    case PRETAX_ACCOUNT_TYPES.PARKING:
      return ParkingIllustration;
    case PRETAX_ACCOUNT_TYPES.FSA:
      return FsaIllustration;
    case PRETAX_ACCOUNT_TYPES.LPFSA:
    case PRETAX_ACCOUNT_TYPES.LPFSAHSA:
    case PRETAX_ACCOUNT_TYPES.HSA:
      return HsaIllustration;
    case TWIC_ACCOUNT_TYPES.WELLNESS:
      return WellnessIllustration;
    case TWIC_ACCOUNT_TYPES.REWARDS:
      return RecognitionIllustration;
    case TWIC_ACCOUNT_TYPES.FAMILY:
      return FamilyIllustration;
    case TWIC_ACCOUNT_TYPES.COMMUNICATIONS:
      return WorkFromHomeIllustration;
    case TWIC_ACCOUNT_TYPES.PET:
      return PetsIllustration;
    case TWIC_ACCOUNT_TYPES.BIKING:
      return CommuterIllustration;
    default:
      return CustomIllustration;
  }
};

interface Props {
  wallet_type_id?: string;
  className?: string;
}

const WalletIcon = ({ wallet_type_id, className }: Props) => (
  <WalletImg
    alt="wallet"
    className={className}
    src={getIllustrationImg(wallet_type_id ?? '')}
  />
);

export default WalletIcon;
